import { keyBy } from 'lodash';
import { useMemo } from 'react';
import { SignalOutputCard } from 'components/organisms/signal-output';
import { SignalDetailsSectionComponentProps } from './types';

export const SignalGeneratedSection = ({
  node,
}: SignalDetailsSectionComponentProps) => {
  const signalsSelected = node.attrs.response?.signalOccurences ?? [];
  const detectedSignals = useMemo(
    () => node.attrs.response?.detectedSignals ?? [],
    [node.attrs.response?.detectedSignals],
  );
  const detectedSignalMap = useMemo(
    () => keyBy(detectedSignals, 'signalConfigurationId'),
    [detectedSignals],
  );

  return (
    <div contentEditable={false}>
      {signalsSelected.map((signal) => {
        const reason = signal?.fields?.find(
          (field) =>
            Object.keys(signal?.metaData)[0] === String(field?.fieldId),
        );

        return (
          <SignalOutputCard
            key={signal?.signalOccurrenceId}
            people={signal?.reportedBy ?? []}
            reason={reason}
            title={signal?.title}
            description={signal?.summary}
            tasks={[]}
            insightfulContent={''}
            citations={signal?.citationMapping}
            signalType={
              detectedSignalMap[signal?.signalConfigurationId]?.signalType
            }
            type={
              detectedSignalMap[signal?.signalConfigurationId]?.signalName ?? ''
            }
            className="timeline-details-signal"
          />
        );
      })}
    </div>
  );
};
